import { getRateList, SupportedCurrencyInfo } from 'api/common'
import { selectorWithoutCache as selector } from 'util/RecoilWithoutCache'
import { isSuccess } from 'util/Common'
import { atom } from 'recoil'
import LocalCookie, { CookieKey } from 'util/LocalCookie'
import { DEFAULT_CURRENCY } from 'constants/base'

function getCachedUnit() {
    let cache = LocalCookie.get(CookieKey.UNIT) as string
    if (typeof cache === 'string') {
        return cache.toUpperCase()
    } else {
        return DEFAULT_CURRENCY
    }
}

/**
 * 所选货币单位
 */
export const CurrencyUnitState = atom({
    key: 'CurrencyUnitState',
    default: getCachedUnit()
})

export const CurrencyUnitSelector = selector({
    key: 'CurrencyUnitSelector',
    get: ({ get }) => {
        return get(CurrencyUnitState)
    },
    set: ({ set }, newValue: string) => {
        newValue = newValue.toUpperCase()
        try {
            LocalCookie.set(CookieKey.UNIT, newValue)
            set(CurrencyUnitState, newValue)
        } catch (e) {
            console.error('set CurrencyUnitState error', e)
        }
    }
})

export const EmptySupportedCurrencyInfo: SupportedCurrencyInfo = {
    rates: {},
    country: {},
    supported: []
}
const SupportedCurrencyInfoState = atom({
    key: 'SupportedCurrencyInfoState',
    default: EmptySupportedCurrencyInfo
})
/**
 * 获取支持的货币信息
 */
export const SupportedCurrencyInfoSelector = selector<SupportedCurrencyInfo>({
    key: 'SupportedCurrencyInfoSelector',
    get: ({ get }) => {
        return get(SupportedCurrencyInfoState)
    },
    set: ({ set }, newValue: SupportedCurrencyInfo) => {
        set(SupportedCurrencyInfoState, newValue)
    }
})

/**
 * 支持的换算汇率列表
 */
export const SupportedCurrencyListSelector = selector({
    key: 'SupportedCurrencyListSelector',
    get: ({ get }) => {
        const currencyInfo = get(SupportedCurrencyInfoSelector)
        return currencyInfo?.supported || []
    }
})

/**
 * 支持的国家代码与汇率映射
 */
export const CountryCurrencyMapSelector = selector({
    key: 'CountryCurrencyMapSelector',
    get: ({ get }) => {
        const currencyInfo = get(SupportedCurrencyInfoSelector)
        return currencyInfo?.country || {}
    }
})

/**
 * 汇率值
 */
export const CurrencyRateMapSelector = selector({
    key: 'CurrencyRateMapSelector',
    get: ({ get }) => {
        const currencyInfo = get(SupportedCurrencyInfoSelector)
        return currencyInfo?.rates || {}
    }
})

/**
 * 汇率币种符号
 */
export const CurrencySymbolSelector = selector({
    key: 'CurrencySymbolSelector',
    get: ({ get }) => {
        const currencyUnit = get(CurrencyUnitSelector)
        const supportedCurrencyList = get(SupportedCurrencyListSelector)
        return (
            supportedCurrencyList.find(i => i?.name?.toUpperCase() === currencyUnit)?.symbol || ''
        )
    }
})

/**
 * 注意：该selector的使用场景比较简单，但是也要消除CurrencyUnitSelector和CurrencyRateSelector同时使用的场景
 */
export const CurrencyRateSelector = selector<string>({
    key: 'CurrencyRateSelector',
    get: ({ get }) => {
        const currencyUnit = get(CurrencyUnitSelector)
        const supportedCurrencyList = get(SupportedCurrencyListSelector)
        const currencyRateMap = get(CurrencyRateMapSelector)
        const currencyKey =
            supportedCurrencyList.find(i => i?.name?.toUpperCase() === currencyUnit)?.value || ''
        return currencyKey in currencyRateMap ? currencyRateMap[currencyKey] : '1'
    }
})

/**
 * 当前展示还是隐藏资产 只有kol配置白名单才会展示开关
 */
export const CurrentAssetsShowState = atom<boolean>({
    key: 'current-assets-show-state',
    default: false
})
